/**
 * LOT-UI-02 — Palette recherche ⌘K / Ctrl+K
 */
import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import GlobalSearch from './GlobalSearch';

const GlobalSearchPalette = ({ open, onClose, api }) => {
  useEffect(() => {
    const onKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        if (open) onClose();
        else window.dispatchEvent(new CustomEvent('rm-open-search'));
      }
      if (e.key === 'Escape' && open) onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[300] flex items-start justify-center pt-[12vh] px-4 bg-black/60 backdrop-blur-sm" data-testid="global-search-palette" onClick={onClose}>
      <div className="w-full max-w-xl rounded-2xl border border-white/10 bg-[#141820] shadow-2xl p-4" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-3">
          <span className="text-sm font-semibold text-white">Recherche universelle</span>
          <button type="button" onClick={onClose} className="p-1 rounded-lg text-gray-500 hover:text-white hover:bg-white/10">
            <X className="w-4 h-4" />
          </button>
        </div>
        <GlobalSearch api={api} compact autoFocus onClose={onClose} />
        <p className="mt-3 text-[10px] text-gray-500 text-center">Réparation · Vente · Client · Tél · Stock · IMEI · ⌘K</p>
      </div>
    </div>
  );
};

export default GlobalSearchPalette;
